import {
  FormFieldSchema,
  FormFieldType,
} from "@app/components/forms/types/schema";

export const BlogpaySchema: FormFieldSchema[] = [
  {
    id: "id",
    label: "블로그페이 아이디",
    placeholder: "블로그페이 아이디를 입력해주세요.",
    type: FormFieldType.Text,
    behavior: {
      required: true,
    },
  },
  {
    id: "password",
    label: "블로그페이 비밀번호",
    placeholder: "블로그페이 비밀번호를 입력해주세요.",
    type: FormFieldType.Password,
    behavior: {
      required: true,
    },
  },
];
